import { render } from "./batteryFault.vue?vue&type=template&id=381c3684&scoped=true"
import script from "./batteryFault.vue?vue&type=script&lang=js"
export * from "./batteryFault.vue?vue&type=script&lang=js"

import "./batteryFault.vue?vue&type=style&index=0&id=381c3684&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381c3684"]])

export default __exports__